import React from 'react';
import clsx from 'clsx';
import { useDispatch, useSelector } from 'react-redux';
import { useMediaQuery } from '@mui/material';
import FuseNavigation from '@fuse/core/FuseNavigation';
import type { FuseNavigationProps } from '@fuse/core/FuseNavigation/FuseNavigation';

import { selectNavigation } from 'app/store/fuse/navigationSlice';
import { navbarCloseMobile } from '../../store/fuse/navbarSlice';

type NavigationProps = Pick<FuseNavigationProps, 'className' | 'layout' | 'dense' | 'active'>;

function Navigation({ layout = 'vertical', ...otherProps }: NavigationProps) {
	const dispatch = useDispatch();
	const isMdDown = useMediaQuery(theme => theme.breakpoints.down('md'));

	const navigation = useSelector(selectNavigation);

	function handleItemClick(item) {
		if (isMdDown) dispatch(navbarCloseMobile());
	}

	return (
		<FuseNavigation
			className={clsx('navigation', otherProps.className)}
			navigation={navigation}
			layout={layout}
			dense={otherProps.dense}
			active={otherProps.active}
			onItemClick={handleItemClick}
		/>
	);
}

export default React.memo(Navigation);
